<template>
<section>

  <section v-if="orders.length > 0" :class="{blurredBg: isBusy}">
    <!-- <pre>
                  {{ orderIdsForApiShippingRequest }}
                </pre>
                <hr>
                <pre>
                  {{ finalShippingOrdersForApiCall }}
                </pre> -->

    <b-row>
      <b-col>
        <b-pagination :total-rows="data.count" v-model="data.page" :per-page="data.pageSize" @input="fetchOrders">
        </b-pagination>

        
      </b-col>
      <b-col>
        <b-button variant="outline-primary" @click.prevent="bulkActionVisible = !bulkActionVisible"> Bulk Update   <i class="fa m-l-5" :class="{'fa-chevron-down': !bulkActionVisible, 'fa-chevron-up': bulkActionVisible}" aria-hidden="true"></i></b-button>
      </b-col>
      <b-col>
        <b-dropdown id="dropdown-right" size="sm" dropleft right text="Actions" variant="outline-primary" class="float-right">
          <b-dropdown-item href="#" @click="toggleOrderItems">Toggle order details</b-dropdown-item>
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-group id="dropdown-group-1" header="Actions on collection">
            <b-dropdown-item href="#" @click.prevent="addForShipping">Add for DHL Shipping</b-dropdown-item>
            <b-dropdown-item href="#" @click.prevent="reprintLabelsForSelectedOrders">Reprint Shipping Labels</b-dropdown-item>
            <b-dropdown-item href="#" @click.prevent="deleteSelectedShippingRecords">Delete Shipping records</b-dropdown-item>
            <b-dropdown-item href="#" @click.prevent="closeOutSelectedBatch">Closeout Shipping Batches</b-dropdown-item>
          </b-dropdown-group>
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item href="#" @click.prevent="downloadLabelsAsZip">Download Ship. Labels as zip</b-dropdown-item>
          <!-- <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-group id="dropdown-group-2" header="Actions on tags">
            <b-dropdown-item href="#" @click.prevent="showAllTags('show')">Show Tags</b-dropdown-item>
            <b-dropdown-item href="#" @click.prevent="showAllTags('hide')">Hide Tags</b-dropdown-item>
          </b-dropdown-group> -->
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-group id="dropdown-group-3" header="Orders Actions">
              <b-dropdown-item href="#" @click.prevent="showOrdersImportModal()">Update Orders using excel</b-dropdown-item>
          </b-dropdown-group>
          <list-actions v-if="activeOrdersList.value" />
        </b-dropdown>
      </b-col>
    </b-row>

    <missing-order-records v-if="shouldShowMissingOrdersAlert && !isBusy" :order-nos="orders.map(order => order.order_no)"/>

    <bulk-update :orders="ordersForBulkUpdate" :visibility="bulkActionVisible" />
    <div class="recordCounts">Total search records count : {{ data.count }}</div>

    <section class="custom-table">
      <div class="single-row single-row-heading sticky-header">
        <dot-labels />
        <div class="p-5-px">
          <b-row no-gutters>
            <b-col cols="1">
              <b-form-checkbox v-model="selectAll" name="selectAll" :value="'yes'" :unchecked-value="'no'" @change="toggleSelectAll">

              </b-form-checkbox>

            </b-col>
            <b-col cols="2">
              Order No.
            </b-col>
            <b-col cols="2">
              Utilities
            </b-col>
            <b-col cols="1">
              Items
            </b-col>
            <b-col cols="1">
              Currency
            </b-col>
            <b-col cols="2">
              Created
            </b-col>
            <b-col cols="2" class="text-right">
              Actions
            </b-col>
          </b-row>
        </div>
      </div>

      <div class="single-row single-row-body" v-for="order in orders" :key="order.id">

        
        

        <div class="error-symbol" v-show="order.shippingValidationError">
          <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
        </div>

        <!-- Note -->
        <a href="#" @click.prevent="accessNote(order.id, 'Order', order.order_no,)" title="Order Notes" class="notes-link" :class="{active: order.UserNotes.length }">
          <b-icon icon="layout-text-sidebar-reverse"></b-icon> {{ order.UserNotes.length }}

        </a>

        <!-- Customer Draft Trigger -->
        <a href="#" title="Image Draft" class="imgDraft" :class="{active: order.CustomerDrafts.length > 0}" @click.prevent="accessDraft(order.order_no, order.id)">{{ order.CustomerDrafts ? order.CustomerDrafts.length : 0 }}
          <b-icon icon="images"></b-icon> <span>Drafts</span>
        </a>

        <!-- Delivered -->
        <div v-if="order.OrderShippings.length > 0" class="delivered-symbol" :class="{'delivered': order.OrderShippings.length > 0 && order.OrderShippings[0].isDelivered == 'Yes' }" v-b-tooltip.hover title="Package Tracking" @click="showTrackingData(order.id, order.order_no, order.OrderShippings)">
          D
        </div>

        <!-- Status Setter -->
        <section class="status-setter-opener">
          <div v-if="order.OrdersAndItemsStatusHistories.length > 0">
            <b-link class="lastStatus" :style="{backgroundColor:order.OrdersAndItemsStatusHistories[0].OrdersAndItemsStatus.colorCode }" href="#" @click.prevent="showManageStatusModal(order)">{{ order.OrdersAndItemsStatusHistories[0].OrdersAndItemsStatus.title }}
            </b-link> {{ order.OrdersAndItemsStatusHistories[0].createdAt | moment("from", "now") }}
          </div>
          <div v-else>
            <b-link href="#" @click.prevent="showManageStatusModal(order)" class="no-status">Set Status</b-link>
          </div>
        </section>

        <b-row no-gutters>
          <b-col cols="1">
            <b-form-checkbox v-model="order.selected" name="selectedforshipping" :value="'yes-' + order.id + '-' + order.order_no" :unchecked-value="'no-' + order.id + '-' + order.order_no" @change="isRecordSelected" class="m-t-5">
            </b-form-checkbox>
          </b-col>
          <b-col cols="2" class="m-t-5 clearfix">
            <div v-if="order.fulfillmentStatus == 'fulfilled'" class="float-left m-t-2">
              <div v-b-tooltip.hover :title="`Fulfillment Status: ${order.fulfillmentStatus == 'fulfilled' ? 'Fulfilled' : 'Unknown/Unfulfilled'}`">
              <span class="material-icons d-inline-block text-success" >
                 check_circle
              </span>
              </div>
            </div>
            <label class="badge badge-dark" >{{ order.order_no }}
              
            </label>
            <span class="order-event-timeline-trigger" title="Events Timeline" v-b-modal.order_events_timeline_modal @click="showOrderEvents(order.id)"><img src="https://sellerdawn-system.s3.ap-south-1.amazonaws.com/A-A-Enterprise/2021-09-17/2021-09-17_09-15-12-timeline%20%286%29.png" alt=""></span>
            <v-popover>
              <!-- <button class="tooltip-target b3 trackingBtn"><i class="fa fa-map-marker" aria-hidden="true"></i></button> -->

              <template slot="popover">
                <label class="m-t-5">Update Tracking ID</label>
                <input class="tooltip-content " v-model="order.deliveryConfirmationNo" placeholder="DHL Tracking ID" @input="updateSingleValueFromOrderTable('order', order.id, 'deliveryConfirmationNo', order.deliveryConfirmationNo)" />
                <a v-close-popover>Close</a>
              </template>
            </v-popover>

          </b-col>
          <b-col cols="2">
            <b-button v-b-modal.modallg variant="outline-primary" size="xs" @click="showDetails(order)">Details</b-button>
            <i class="fa fa-chevron-down m-l-5 view-details" aria-hidden="true" @click="toggleItemVisiblity(order)"></i>
            
          </b-col>

          <b-col cols="1" class="m-t-5">
            {{ order.ShopifyOrderItems.length }}
          </b-col>
          <b-col cols="1" class="m-t-5">
            {{ order.currency }}
          </b-col>
          <b-col cols="2" class="m-t-5">
             <div class="orderDateTime">
               <div>Order datetime UTC</div>
               {{ moment(order.created_in_shopify).utc().format('DD-MM-YYYY, h:mm a') }}
               <section class="inSystemDateTime">
                <div>
                  Received in SellerDawn (UTC)
                </div>
                {{ moment(order.createdAt).utc().format('DD-MM-YYYY, h:mm a') }}
              </section>
             </div>
             
          </b-col>
          <b-col cols="2" class="m-t-5 text-info">
            <div>

              <b-dropdown size="xs" split id="dropdown-1" variant="primary" text="Actions" class="float-right">
                <b-dropdown-item @click="manageTagsModal(order.tags, order.id)">Manage Shopify Tags</b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item @click="refreshOrder(order.id, order.shopify_id, order.shopify_store_id)">Refresh Order</b-dropdown-item>
              </b-dropdown>

            </div>

          </b-col>
        </b-row>

        

        <section class="secondInfoRow">
          <b-row class="m-t-10">
            <b-col cols="1">
              <span class="dot" :class="{'dot-1': order.shippingId, 'half-complete': !order.labelInTextFormat}">
              </span>
              <span class="dot" :class="{'dot-2': order.closeoutId}"></span>
              <span class="dot"></span>
            </b-col>
            <b-col cols="3">
             
                <!-- <div>
                  <span>Ship. Id:</span> {{ order.shippingId ? order.shippingId : '~Nil~'  }}
                </div> -->
                <shipping-ids-dropdown :order-shippings="order.OrderShippings"/>
             
            </b-col>
            <b-col cols="3">
              <div class="light-txt">
                <div>
                  <span>Ship. Batch:</span> {{ order.shippingBatch ? order.shippingBatch : '~Nil~' }}
                </div>
              </div>
            </b-col>
            <b-col cols="3">
              <div class="light-txt">
                <div>
                  <span>Cnty :</span>
                  {{ order.ShopifyShippingAddress.country}} ({{order.ShopifyShippingAddress.countryCode}})
                </div>
              </div>
            </b-col>
            <b-col cols="2">
              <b-button variant="light" size="xs" v-b-modal.log_modal @click="showLogs(order.id)">
                <i class="fa fa-list-ul" aria-hidden="true"></i> DHL Req. Logs
              </b-button>
            </b-col>
          </b-row>

        </section>

        <order-extra-info :conversion-source="order.referringSite" :shipping-type="order.processingMethod"/>

        <section>
          <b-list-group class="m-b-10 m-t-10">
            <b-list-group-item class="d-flex justify-content-between align-items-center p-t-60" v-for="(item, index) in order.ShopifyOrderItems" v-bind:key="item.id">
              <div>
                <quick-status :latest-status="item.statusHistory" :item-statuses="itemStatusesOptions" :id="item.id" :order-id="order.id" :tags="order.tags" />

                <add-to-item-list :order-id="order.id" :id="item.id"  level="item" :should-be-active="canBeAddedToPrintQueue(order.ShopifyStore ? order.ShopifyStore.ExtraStatuses : extraStatuses, order.extraStatus)"/>
                
                <!-- Tooltip for details -->
                <v-popover offset="16" placement="top" popoverClass="item-info-tooltip" trigger="hover">
                  <span class="tooltip-target b3">{{index+1}}. {{ item.variant_title }}</span>
                  <template slot="popover" class="itemInfoTooltip">
                    <div><strong>SKU: </strong>{{ item.sku }}</div>
                    <div><strong>Name: </strong>{{ item.name }}</div>
                  </template>
                </v-popover>
              </div>
              <!-- ends Tooltip for details -->
              <div>
              <strong>
                Sold At: {{ item.discounts ? (parseFloat(item.price) -  parseFloat(item.discounts[0].amount)).toFixed(2) * item.quantity : item.price * item.quantity }}({{ order.currency  }})</strong>
                <br>
                <span class="calculations">{{ item.discounts ? `${item.price} price - ${item.discounts[0].amount} dis.` :  ''}}</span>
              </div>
              <span class="quantity">Quantity: {{item.quantity}}</span>
              <download-renamed-customer-file :properties="item.properties" :item-name="item.name" :order-no="order.order_no" />
            </b-list-group-item>
          </b-list-group>
        </section>
        <order-items-set :visibility="order.itemsVisible" :items="order.ShopifyOrderItems" :order="filteredOrder(order)"></order-items-set>

        <b-row>
          <b-col cols="4">

          </b-col>
          <b-col class="clearfix" cols="8">
            <b-button v-if="order.tags" variant="link" class="m-l-5 tagTooltip float-right" @click="showOrderTagLogsModal(order.id)">
              <strong>Tags:</strong>
              <div class="tag-display" v-html="order.tags ? order.tags.split(',').map(tag => ('<span>' + tag + '</span>')).join('') : 'No Tags'">
              </div>

            </b-button>

          </b-col>
        </b-row>

        <div v-if="tagsToBeAssigned.length > 0" @click="updateTags(order.id, order.tags, tagsToBeAssigned,)" class="add-selected-tags">
          <b-icon icon="tag"></b-icon> Add Selected Tags
        </div>

        <extra-statuses :extra-statuses="order.ShopifyStore ? order.ShopifyStore.ExtraStatuses : extraStatuses" :active-extra-statuses="order.extraStatus" :order-id="order.id" :log-extra-statuses="order.LogExtraStatuses"/>
        
        <div v-if="order.ShopifyStore" class="m-b-5">
           <strong class="text-success">Store Name:</strong> {{ order.ShopifyStore.identifier }}
        </div>
        
        <add-to-list-widget :order-id="order.id" v-if="activeOrdersList.value" :list-data-active="data.ordersListId ? false : true"/>

        <customer-note v-if="order.customerNote" :note="order.customerNote"/> 

        <add-to-item-list :order-id="order.id" :id="order.id" level="order" :item-in-list="order.ChildItemsInList" :should-be-active="canBeAddedToPrintQueue(order.ShopifyStore ? order.ShopifyStore.ExtraStatuses : extraStatuses, order.extraStatus)"/>
      </div>
      <!--Single Order Div Ends -->
    </section>
    <div class="recordCounts">Total search records count : {{ data.count }}</div>
    <b-pagination class="m-t-30" :total-rows="data.count" v-model="data.page" :per-page="data.pageSize" >
    </b-pagination>
  </section>
  <!-- {{ storeSelected }} - {{ data.ordersListId }} - {{ orders.length }} - {{ isBusy }} -->
  <section v-if="(storeSelected || data.ordersListId) && orders.length == 0 && !isBusy" class="no-data-found">
    <div>
      🙂 Hey There! No Data found for the specified conditions. <br>
      Please try another combination.
    </div>
  </section>

  <div v-if="!storeSelected && !data.ordersListId  && !isBusy">
    <b-jumbotron text-variant="dark">
      <template v-slot:header>Select a store or orders list</template>

      <template v-slot:lead>
        Here you will find the orders for different stores
      </template>

      <hr class="my-4">

      <p>
        You can also use the advanced filters to control your search.

      </p>
    </b-jumbotron>
  </div>

  <order-details />
  <order-logs />
  <order-tags-modal />
  <customer-files-modal />
  <statuses-modal />
  <order-tag-logs />
  <log-extra-statuses-modal />
  <order-events-timeline />
  <vue-fab mainBtnColor="#3599DB">
    <fab-item @clickItem="toggleOrderItems" :idx="3" title="Toggle Order Items" icon="remove_red_eye" :color="'#2a9d8f'" />
    <fab-item :color="'#e76f51'" @clickItem="addForShipping" :idx="2" title="Add Selected for DHL Shipping" icon="https" />
    <fab-item :color="'#264653'" @clickItem="downloadLabelsAsZip" :idx="1" title="Download Ship. Labels as zip" icon="cloud_download" />
    <fab-item :color="'#ff1654'" @clickItem="closeOutSelectedBatch" :idx="0" title="Closeout selected batch" icon="edit" />
  </vue-fab>

  <robot-loader v-show="isBusy" />
  <dhl-tracking />
  <order-import-modal />
  <send-mail-and-sms :list="activeOrdersList"/>
  
</section>
</template>

<script>
const OrderDetails = () => import( /* webpackChunkName: "orders.order-details" */ '../order-details');
const OrderLogs = () => import( /* webpackChunkName: "orders.order-logs" */ '../order-logs');
const OrderItemsSet = () => import( /* webpackChunkName: "orders.order-items-set" */ '../order-items-set');
const OrderTagsModal = () => import( /* webpackChunkName: "orders.tags-modal" */ '../order-tags-modal');

const BulkUpdate = () => import( /* webpackChunkName: "orders.bulk-update" */ '../bulk-update');
const CustomerFilesModal = () => import( /* webpackChunkName: "orders.customer-files-modal" */ '../customer-files-modal')
const OrderTagLogs = () => import( /* webpackChunkName: "order.tag-logs" */ "../order-tag-logs.vue")
const StatusesModal = () => import( /* webpackChunkName: "order.statuses-modal" */ "../statuses/statuses-modal");
const DhlTracking = () => import( /* webpackChunkName: "order.dhl-tracking" */ "../tracking/dhl-tracking")
const DownloadRenamedCustomerFile = () => import( /* webpackChunkName: "order.download-renamed-customer-file" */ "../download-renamed-customer-file");

const QuickStatus = () => import( /* webpackChunkName: "order-and-items-quick-status" */ "../statuses/quick-status");

const ExtraStatuses = () => import( /* webpackChunkName: "extra-statuses" */ "../partials/extra-statuses")

const OrderImportModal = () => import( /* webpackChunkName: "order-import-modal" */ "../partials/order-import-modal")
const ShippingIdsDropdown = () => import(/* webpackChunkName: "shipping-ids-dropdown" */ '../partials/shipping-ids-dropdown')

const AddToListWidget = () => import(/* webpackChunkName: "add-to-list-widget"*/ "../list/add-to-list-widget")
const ListActions = () => import(/* webpackChunkName: "list-actions" */ "../list/list-actions/list-actions");

const SendMailAndSms = () => import(/* webpackChunkName: "send-mail-and-sms" */ "../list/list-actions/send-mail-and-sms")
const CustomerNote = () => import(/* webpackChunkName: "customer-note" */ "../partials/customer-note");
const OrderExtraInfo = () => import(/* webpackChunkName: "order-extra-info" */ '../partials/order-extra-info');

const MissingOrderRecords = () => import(/* webpackChunkName: "missing-order-records" */ '../partials/missing-order-records');

const AddToItemList = () => import(/* webpackChunkName: "add-to-item-list" */ "../../../components/item-list/add-to-item-list")

const OrderEventsTimeline = () => import(/* webpackChunkName: "order-events-timeline" */ "../events-timeline/order-events-timeline.vue")

import RobotLoader from '../../../components/common/RobotLoader';

import EventBus from '../../../EventBus';
import DotLabels from '../partials/dot-labels';
import MethodMixins from './methods-mixin';
const LogExtraStatusesModal = () => import(/* webpackChunkName: "log-extra-statuses-modal" */ '../partials/log-extra-statuses-modal')
import moment from 'moment';

import io from 'socket.io-client';
import { IS_LIVE } from '../../../services/constants';
const SOCKET_NAMESPACE = '/item-list-section';

import Vue from 'vue'
export default {
  name: "orders-table",
  mixins: [MethodMixins],
  props: {
    tableHeaderColor: {
      type: String,
      default: "",
    }
  },
  async mounted() {

    EventBus.$on('search-term-order-search', (data) => {
      

      // Get Extra status list for a store
      if(this.data.store_id !== data.store_id){
        this.fetchExtraStatus(data.store_id);
      }

      this.storeSelected = data.store_id ? true : false;
      this.fetchStoreData(data);

    })
    EventBus.$on('order-per-page-changed', (count) => {
      this.updatePerPageRecord(count);
    })
    EventBus.$on('order-advanced-filter-changed', (dates) => {
      this.fetchWithAdvancedFilters(dates);
    })

    EventBus.$on('orders.bulk-type-updated', (bulkType) => {
      this.typeOfBulkUpdate = bulkType;
    });



    EventBus.$on('order-and-item-status-modal-closed', (theOrder) => {
      this.orders.forEach((order, index) => {
        if (theOrder.id == order.id) {
          Vue.set(this.orders, index, theOrder);
        }
      });
    });

    EventBus.$on('status.updated-item-status', (theOrder) => {

      this.orders.forEach((order, index) => {
        if (theOrder.id == order.id) {
          Vue.set(this.orders, index, theOrder);
        }
      });

    });

    EventBus.$on('item-in-list-added', (theOrder) => {

      this.orders.forEach((order, index) => {
        if (theOrder.id == order.id) {
          Vue.set(this.orders, index, theOrder);
        }
      });

    });

    // Remove the validation error when shipping fields are not empty
    EventBus.$on('orders.remove-shipping-empty-field-error', (id) => {
      console.log('Id for error removal', id)
      this._.forEach(this.orders, (order, index) => {
        if (order.id == id) {
          order.shippingValidationError = false;
        }
      })
    });
    

    // Fill the validated data.
    EventBus.$on('orders.update-single-order-data-each-ship-validation', (order) => {
      let targetOrder = this.orders.find(ord => ord.id == order.id);
      if (targetOrder) {

        targetOrder.incoterm = order.incoterm;
        targetOrder.dhlService = order.dhlService;
        targetOrder.weightTakenAfterPackaging = order.weightTakenAfterPackaging;
        targetOrder.packageDesc = order.packageDesc;
        targetOrder.ShopifyShippingAddress.province = order.shippingState;
        // Update the order items
        order.ShopifyOrderItems.forEach(item => {
          let targetItem = targetOrder.ShopifyOrderItems.find(itm => itm.id == item.id);
          if (targetItem) {
            targetItem.hsCode = item.hsCode;
            targetItem.setPrice = item.setPrice;
          }
        })
      }

    });

    EventBus.$on('orders.bulk-fields-with-items-updated', () => {
      let orderOpenState = this.orders.map(order => {
        return order.itemsVisible;
      });
      this.fetchOrders(orderOpenState);

    })

    EventBus.$on('order-tag-updated', ({
      id,
      tags
    }) => {
      console.log('Order tag updated', tags)
      const specific_record = this.orders.find(order => order.id == id);
      let tagsString = tags.join(',');

      if (specific_record) {
        specific_record.tags = tagsString;
      }

    })

    EventBus.$on('tag-to-be-assigned', selectedTags => {
      this.tagsToBeAssigned = selectedTags
    })

    // Logic to increase count of notes in display
    EventBus.$on('update-note-count', data => {
      
      let particularOrder = this.orders.find(order => data.recordId == order.id);

      particularOrder.UserNotes = [];
      console.log(data.count)
      for (let i = 0; i < data.count; i++) {
        particularOrder.UserNotes.push({})
      }

    })

    EventBus.$on("customer-draft.sent", ({
      order
    }) => {
      order.itemsVisible = false;
      this.orders.forEach((single_order, index) => {
        if (order.id == single_order.id) {
          Vue.set(this.orders, index, order);
        }
      });
    })

    EventBus.$on("extra-status-modified", (
      order
    ) => {
      this.orders.forEach((single_order, index) => {
        if (order.id == single_order.id) {
          Vue.set(this.orders, index, order);
        }
      });
    })

    EventBus.$on("refetced-shopify-order", (
      order
    ) => {
      console.log('Refetched', order);
      this.orders.forEach((single_order, index) => {
        if (order.id == single_order.id) {
          Vue.set(this.orders, index, order);
        }
      });
    })


    EventBus.$on('load-list-data', orderListId => {
      console.log("Orders with items component - Load list data");
      this.resetDataObj()
      this.storeSelected = false;
      this.data.ordersListId = orderListId;
      this.fetchOrders();
    })

    EventBus.$on('exited-list', () => {
      this.resetDataObj()
      this.data.ordersListId = null;
      this.storeSelected = false;
      this.orders = [];
    })

    EventBus.$on('notify-others-items-in-list-added', () => {
      this.socket.emit('ITEM_LIST.NEW_DATA', moment.utc().format());
    })


    

    document.body.style.overflowX = 'unset';
    document.getElementsByClassName('container-scroller')[0].style.overflow = 'unset';

  },
  data() {
    return {
      orders: [],
      orderForShipping: [],
      isBusy: false,
      selectAll: "no",
      fields: [{
          key: 'selected',
          label: 'SELECTED'
        },
        {
          key: 'index',
          label: '#'
        },
        {
          key: 'id',
          label: 'Utilities'
        },
        {
          key: 'order_no',
          sortable: true
        },
        {
          key: 'item_count',
          label: 'Total Items'
        },
        {
          key: 'currency'
        },
        {
          key: 'created_in_shopify'
        },
        {
          key: 'updated_at_shopify'
        },
      ],
      errors: '',
      data: {
        page: 1,
        pageSize: 25,
        count: 0,
        store_id: 0,
        statusSelected: null,
        searchTerm: null,
        created_start_date: '',
        created_end_date: '',
        extraStatuses: [],
        ordersListId: null,
        referringSite: '',
        processingMethod: ''
      },
      typeOfBulkUpdate: 'all',
      bulkActionVisible: false,
      showTags: false,
      storeSelected: false,
      tagsToBeAssigned: [],
      itemStatusesOptions: [],
      extraStatuses: [],
      showEmailSmsModal: false,
      socket : io(`${IS_LIVE ? '' : 'http://localhost:3000'}${SOCKET_NAMESPACE}`),
    };
  },
  components: {
    OrderDetails,
    OrderItemsSet,
    BulkUpdate,
    OrderLogs,
    DotLabels,
    RobotLoader,
    OrderTagsModal,
    CustomerFilesModal,
    OrderTagLogs,
    StatusesModal,
    DhlTracking,
    DownloadRenamedCustomerFile,
    QuickStatus,
    ExtraStatuses,
    OrderImportModal,
    ShippingIdsDropdown,
    AddToListWidget,
    ListActions,
    SendMailAndSms,
    CustomerNote,
    OrderExtraInfo,
    LogExtraStatusesModal,
    AddToItemList,
    MissingOrderRecords,
    OrderEventsTimeline
  },
  computed: {
    orderIdsForApiShippingRequest() {
      return this.$store.state.orders.idArray;
    },
    finalShippingOrdersForApiCall() {
      return this.$store.state.orders.ordersForShipping;
    },
    ordersForBulkUpdate() {
      if (this.typeOfBulkUpdate == 'all') {
        return this.orders.map(order => {
          return {
            id: order.id,
            items: order.ShopifyOrderItems.map(item => item.id)
          }
        })
      } else {
        return this.orders.filter(order => {
          return order.selected == `yes-${order.id}-${order.order_no}`;
        }).map(order => {
          return {
            id: order.id,
            items: order.ShopifyOrderItems.map(item => item.id)
          }
        })
      }
    },
    ordersCheckboxSelected() {
      return this.orders.filter(order => {
        return order.selected == `yes-${order.id}-${order.order_no}`;
      }).map(order => {
        return {
          id: order.id,
          orderNo: order.order_no,
          shippingId: order.shippingId,
          closeoutId: order.closeoutId,
          hasShippingLabel: order.labelInTextFormat ? true : false,
          items: order.ShopifyOrderItems.map(item => item.id)
        }
      })
    },
    // See if list add mode should be active.
    activeOrdersList(){
          return this.$store.state.ordersList.activeList
       },
    shouldShowMissingOrdersAlert(){
       let shouldShow = true;
       if(this.data.statusSelected || this.data.searchTerm || this.data.created_start_date || this.data.created_end_date || this.data.extraStatuses.length > 0 || this.data.ordersListId || this.data.referringSite || this.data.processingMethod){
         shouldShow = false;
       }
       return shouldShow;
    }
  },
  beforeDestroy() {
    EventBus.$off('order-per-page-changed');
    EventBus.$off('order-filter-date-changed');
    EventBus.$off('orders.bulk-type-updated');
    EventBus.$off('orders.bulk-fields-with-items-updated');
    EventBus.$off('orders.remove-shipping-empty-field-error');
    EventBus.$off('orders.update-single-order-data-each-ship-validation');
    EventBus.$off('search-term-order-search');
    EventBus.$off('order-and-item-status-modal-closed');
    EventBus.$off('tag-to-be-assigned');
    EventBus.$off('status.updated-item-status')
    EventBus.$off("customer-draft.sent")
    EventBus.$off("extra-status-modified")
    EventBus.$off('load-list-data')
    EventBus.$off('exited-list')
    EventBus.$off("refetced-shopify-order")
    EventBus.$off('notify-others-items-in-list-added')
    EventBus.$off('item-in-list-added')
  }
};
</script>

<style lang="scss" scoped>
.single-row-heading,
.single-row-body {
  font-size: 13px;
  margin-right: 40px;
}

.view-details {
  cursor: pointer;
  font-size: 11px;
}

.single-row-heading {
  background-color: rgb(62, 74, 87);
  border-bottom: 1px solid rgb(230, 228, 228);
  color: #fff;

  div[class*="col-"] {
    margin-top: 5px;
  }

  margin-bottom: 5px;

}



.single-row-body {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.14);
  transition: all 0.3s cubic-bezier(.25, .8, .25, 1);
  padding: 5px;
  margin-bottom: 10px;
  background-color: white;
  position: relative;
  padding-bottom: 40px;
  /* z-index:2; */

  border-radius: 5px;
  transform-style: preserve-3d;
}

.single-row-body:hover {
  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);

  
}

/* .custom-table {
  background-color: rgb(245, 245, 245);
} */

.m-t-2 {
  margin-top: 2px;
}

.dot {
  width: 10px;
  height: 10px;
  display: inline-block;
  border-radius: 50%;
  background-color: rgb(233, 233, 233);
  margin-right: 5px;
}

.dot-1 {
  background-color: #FF9034;
  position: relative;
}

.dot-1.half-complete::after {
  position: absolute;
  content: '';
  width: 5px;
  height: 10px;
  right: 0px;
  top: 0px;
  border-radius: 0 5px 5px 0;
  background-color: #fff;
  display: block;
}

.dot-2 {
  background-color: #34D633;
}

.dot-3 {
  background-color: #8D3ABC;
}

.dot-label {
  font-size: 13px;
  padding-right: 20px
}

.error-symbol {
  width: 30px;
  height: 30px;
  background-color: rgb(252, 53, 53);
  color: #fff;
  text-align: center;
  line-height: 30px;
  position: absolute;
  left: -30px;
  border-radius: 5px 0 0 5px;

  i {
    animation: blink 1s linear infinite;
  }
}

.light-txt {
  color: rgb(141, 141, 141);
  white-space: nowrap;
  background-color: #fff;
  position: relative;
  transition: all 300ms ease;

  span {
    color: #0BB6FA;
    font-weight: 500;
  }

  div {
    overflow: hidden;
    transition: all 300ms ease;
  }

  &:hover div {
    overflow: visible;
    position: absolute;
    z-index: 2;
    background-color: #0DB3F8;
    padding: 0 3px;
    color: #fff;

    span {
      color: #fff;
    }
  }
}

.secondInfoRow {
  padding: 10px;
  border-top: 1px solid rgb(236, 236, 236);
  margin-top: 10px;
}

/* .tagTooltip {
  text-decoration: none;
  font-size: 13px;
  color: rgb(104, 104, 104);

  i {
    color: orange !important;
  }
} */

.lastStatus {
  text-decoration: none;
  padding: 3px 5px;
  color: #fff;
  font-size: 13px;
  margin-top: 5px;
  display: inline-block;
  border-radius: 3px;
}

.no-status {
  @extend .lastStatus;
  color: #0c6ff1;
}

.status-setter-opener {
  position: absolute;
  left: 5px;
  bottom: 5px;
}

.no-data-found {
  height: 30vh;
  text-align: center;
  background-color: #d1ecf1;
  border-radius: 5px;
  border: 1px solid #bee5eb;
  color: #0c5460;
  font-size: 1.2rem;
  display: flex;
  justify-content: center;
  align-content: center;
  flex-direction: column;
}

.recordCounts {
  font-size: 14px;
  color: rgb(54, 54, 54);
  margin: 10px 0;
}

.v-popover {
  display: inline-block;
  margin-left: 5px;
  margin-top: 2px;
}

$deliveryColor: rgb(107, 212, 37);
$notDeliveredColor: rgb(224, 224, 224);

.delivered-symbol {
  position: absolute;
  right: 10px;
  top: 10px;
  font-size: 18px;
  width: 30px;
  height: 30px;
  text-align: center;
  line-height: 28px;
  font-weight: normal;
  border-radius: 50%;
  color: $notDeliveredColor;
  border: 2px solid $notDeliveredColor;
  cursor: pointer;

  &.delivered {
    border-color: $deliveryColor;
    color: #fff;
    background-color: $deliveryColor;
  }
}

.add-selected-tags {
  position: absolute;
  bottom: 10px;
  right: 10px;
  background-color: rgb(107, 212, 37);
  color: #fff;
  padding: 3px 5px;
  border-radius: 3px;
  font-size: 12px;
  cursor: pointer;
}

.list-group-item {
  padding-left: 30px;
}

.notes-link {
  text-decoration: none;
  position: absolute;
  right: -40px;
  width: 40px;
  z-index: 1;
  display: inline-block;
  background-color: rgb(233, 233, 233);
  color: rgb(107, 107, 107);
  padding: 5px;
  top: 10px;
  border-radius: 0 5px 5px 0;
  &.active {
    background-color: rgb(243, 61, 116);
    color: #fff;
  }
}

.imgDraft {
  display: inline-block;
  position: absolute;
  width: 100px;
  left: -33px;
  white-space: nowrap;
  top: 10px;
  background-color: rgb(52, 50, 66);
  color: #fff;
  padding: 3px 5px;
  border-radius: 3px 0 0 3px;
  transition: all 300ms ease;
  text-decoration: none;
  overflow: hidden;
  transform: translateZ(-10px);

  &.active {
    background-color: rgb(107, 212, 37);
  }

  &:hover {
    left: -100px;
  }

  span {
    display: inline-block;
    margin-left: 10px;
  }
}
.quantity{
  display: inline-block;
  position: absolute;
  left: 3px;
  top: 3px;
  padding: 5px 10px;
  color: rgb(38, 51, 66);
  background-color: rgb(230, 241, 253);
  border-radius: 0 0 5px 0;
  font-weight: 500;
}
.orderDateTime{
  position: relative;

  .inSystemDateTime{
      position: absolute;
      top: 40px;
      z-index: 99;
      padding: 5px 10px;
      box-shadow: 1px 1px 5px rgba(0,0,0,0.3);
      background-color: #fff;
      width: 240px;
      opacity:0;
      transform: translate(40px, 0);
      transition: all 300ms ease;
    }
   &:hover .inSystemDateTime{
     opacity: 1;
     transform: translate(0,0);
   }
}
.calculations{
  color: rgb(61, 190, 1);
}
</style>
